import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';
import useWindowSize from './useWindowSize';

export default () => {
  const windowSize = useWindowSize();

  return (
    <span
      style={{
        width: '100%',
        height: windowSize.height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <CircularProgress />
    </span>
  );
};
